import React, { useEffect } from "react";
import ScrollContainer from "components/general/ScrollContainer";
import { Box, Typography, Button, Icon } from "components/ui";
import { useLocalSearchParams, useRouter } from "expo-router";
import { useNavigation } from "@react-navigation/native";
import { ReportTitles } from "..";
import Container from "components/general/Container";
import Section from "components/general/Section";
import { Animated } from "react-native";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { CheckCircleIcon } from "lucide-react-native";

export default function Page() {
	const navigation = useNavigation();
	const { id } = useLocalSearchParams<{ id: string }>();
	const reportTitle = ReportTitles[Number(id)] || "Unknown Report";
	const isMobile = useIsMobile();

	// Animation setup
	const scaleAnim = React.useRef(new Animated.Value(0)).current;
	const opacityAnim = React.useRef(new Animated.Value(0)).current;

	useEffect(() => {
		Animated.parallel([
			Animated.spring(scaleAnim, {
				toValue: 1,
				useNativeDriver: true,
			}),
			Animated.timing(opacityAnim, {
				toValue: 1,
				duration: 500,
				useNativeDriver: true,
			}),
		]).start();
	}, []);

	return (
		<ScrollContainer>
			<Container>
				<Section>
					<Box padding={isMobile ? 16 : 32} alignItems="center" justifyContent="center" minHeight={400}>
						<Animated.View
							style={{
								transform: [{ scale: scaleAnim }],
								opacity: opacityAnim,
							}}
						>
							<Box borderRadius="$full" p={4} alignItems="center" justifyContent="center" width={80} height={80} backgroundColor="$primarylightblue" marginBottom={24}>
								<CheckCircleIcon size={40} color="white" />
							</Box>
						</Animated.View>

						<Animated.View style={{ opacity: opacityAnim }}>
							<Box alignItems="center" marginBottom={16}>
								<Typography.H1>Success!</Typography.H1>
							</Box>

							<Box alignItems="center" marginBottom={32}>
								<Typography
									sx={{
										fontSize: isMobile ? 16 : 18,
										lineHeight: isMobile ? 24 : 28,
										color: "$neutral600",
									}}
								>
									Your {reportTitle} has been generated successfully and will be emailed to you shortly.
								</Typography>
							</Box>

							<Box gap={16} alignItems="center" flexDirection="row" justifyContent="center">
								<Button variant="primary" isLink  href="/reports" width={isMobile ? "100%" : 200}>
									<Typography color="$basicwhite">Back to Reports</Typography>
								</Button>

								<Button variant="outline" isLink href="/" width={isMobile ? "100%" : 200}>
									<Typography>Return to Home</Typography>
								</Button>
							</Box>
						</Animated.View>
					</Box>
				</Section>
			</Container>
		</ScrollContainer>
	);
}
